import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const CheckboxPresentationPropsDefault: ComponentThemeProps["checkbox"]["defaultProps"] = {
    iconProps: { src: "Check" },
    indeterminateIconProps: { src: "Minus" },
};

export default CheckboxPresentationPropsDefault;
